export const SCHOLAR_PROFILES = [
  { id: "orcid", label: "ORCID", href: "https://orcid.org/0000-0003-4003-5278" },
  { id: "pubmed", label: "PubMed", href: "https://pubmed.ncbi.nlm.nih.gov/?term=0000-0003-4003-5278%5Bauid%5D&sort=date" },
  { id: "scholar", label: "Google Scholar", href: "https://scholar.google.com/citations?user=UBU3Ve8AAAAJ" },
];
